import { ManyToManyFieldPrefix } from './constants';
var getReferenceManyToManyFormField = function (_a) {
    var resource = _a.resource, through = _a.through, reference = _a.reference;
    return "" + ManyToManyFieldPrefix + resource + "/" + through + "/" + reference;
};
export default getReferenceManyToManyFormField;
